import PropTypes from "prop-types"
import React from "react"
import { ToastContainer } from "react-toastify"
import LocationProvider from "../../common/location-provider/location-provider"
import ModalWrapper from "../../common/modal/modal-wrapper/modal-wrapper"
import SearchWrapper from "../../common/search-wrapper/search-wrapper"
import SearchHeader from "../search-header/search-header"
import "./search-layout.scss"

const SearchLayout = ({ children, location, searchPath }) => {

  let title = 'AFPA'
  if (process.env.GATSBY_USE_FHAA === 'true') {
    title = 'FHAA'
  }
  else {
    title = 'AFPA'
  }

  console.log("rendering search layout")

  return (
    <LocationProvider location={location}>
      <ModalWrapper />

      <SearchWrapper index="media" searchPath={searchPath}>
        <SearchHeader siteTitle={title} />
        <main> {children} </main>
        <ToastContainer />
      </SearchWrapper>
    </LocationProvider>
  )
}

SearchLayout.defaultProps = {
  searchPath: "search",
}

SearchLayout.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.object,
  searchPath: PropTypes.string,
}

export default SearchLayout
